import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import css from 'styled-jsx/css';
import { changePage, changePerPage, loadCreatorData } from './actions';
import {
  makeSelectCollection,
  makeSelectLoading,
  makeSelectPagination,
  makeSelectProfile,
} from './selectors';
import ButtonSelect from './ButtonSelect';
import ButtonCopyLink from './ButtonCopyLink';
import ButtonSocialShare from './ButtonSocialShare';
import { makeSelectDataTypePattern } from '../HomePage/selectors';
import { makeSelectCurrentLanguage } from '../Language/selectors';
import { withI18next } from '~/../hocs/_withI18next';
import { Avatar } from '~/lib';
import PaginationNew from '~/components/PaginationNew';
import Gallery from '~/components/Gallery';
import GridGallery from '~/components/Gallery/GridGallery';
import Config from '~/config';
import { urls } from '~/utils';
import FormatNumbers from '~/components/FormatNumbers';
import NextPageButtonNew from '~/components/NextPageButtonNew';
import FacebookComment from '~/components/FacebookComment';
import LoadingSpinner from '~/components/loading-spinner/LoadingSpinner';
import I18nRouter from '~/components/I18nRouter';
import GalleryIllust from '~/components/Gallery/GalleryIllust';
import Container from '~/components/Container';
import { SERVICE_TYPES } from '~/utils/constants';
import IconFacebook from '~/components/svg/icon-facebook-creator.svg';
import IconTwitter from '~/components/svg/icon-twitter-creator.svg';
import IconAccountVerifyPhoto from '~/components/svg/creator-profile/icon-account-verified-creator-photo.svg';
import IconAccountVerifyIllust from '~/components/svg/creator-profile/icon-account-verified-creator-ill.svg';
import IconCountDownloadPhoto from '~/components/svg/creator-profile/icon-count-download-creator-photo.svg';
import IconCountDownloadIllust from '~/components/svg/creator-profile/icon-count-download-creator-ill.svg';
import IconLikePhoto from '~/components/svg/creator-profile/icon-like-creator-photo.svg';
import IconLikeIllust from '~/components/svg/creator-profile/icon-like-creator-ill.svg';
import IcontCountImagePhoto from '~/components/svg/creator-profile/icon-count-image-creator-photo.svg';
import IcontCountImageIllust from '~/components/svg/creator-profile/icon-count-image-creator-ill.svg';
import IconShareProfile from '~/components/svg/creator-profile/icon-share-profile.svg';
import themeVariables from '~/shared/themeVariables';

const ICON_ACCOUNT_VERIFIED_SERVICE = {
  [SERVICE_TYPES.PHOTO_AC]: IconAccountVerifyPhoto,
  [SERVICE_TYPES.ILLUST_AC]: IconAccountVerifyIllust,
};
const IconAccountVerified = ICON_ACCOUNT_VERIFIED_SERVICE[Config.serviceType];

const ICON_COUNT_DOWNLOAD_SERVICE = {
  [SERVICE_TYPES.PHOTO_AC]: IconCountDownloadPhoto,
  [SERVICE_TYPES.ILLUST_AC]: IconCountDownloadIllust,
};
const IconCountDownload = ICON_COUNT_DOWNLOAD_SERVICE[Config.serviceType];

const ICON_LIKE_SERVICE = {
  [SERVICE_TYPES.PHOTO_AC]: IconLikePhoto,
  [SERVICE_TYPES.ILLUST_AC]: IconLikeIllust,
};
const IconLiketDownload = ICON_LIKE_SERVICE[Config.serviceType];

const ICON_COUNT_IMAGE_SERVICE = {
  [SERVICE_TYPES.PHOTO_AC]: IcontCountImagePhoto,
  [SERVICE_TYPES.ILLUST_AC]: IcontCountImageIllust,
};
const IconcCountImage = ICON_COUNT_IMAGE_SERVICE[Config.serviceType];

@withI18next()
class CreatorProfilePage extends React.Component {
  constructor(props) {
    super(props);
    const {
      query: { data_type = 'popular' },
    } = props;

    this.state = { key: data_type, seeMore: false, openShareSocial: false };
  }

  handleSelectTab = (key) => {
    const { creator_id, lng } = this.props;
    I18nRouter.push(
      {
        pathname: `/creator-profile/${creator_id}`,
        query: { data_type: key },
      },
      `/creator-profile/${creator_id}?data_type=${key}`,
    );
    // Router.push({
    //   pathname: `/creator-profile/${creator_id}`,
    //   query: { data_type: key },
    //   shallow: true,
    // });
    this.setState({ key });
  };

  onChangePage = (page) => {
    this.props.changePage(page);
  };

  onPagination = (page) => {
    const { query, creator_id, lng } = this.props;
    this.props.changePage(page);
    this.props.loadCreatorData({ ...query, page });
    I18nRouter.push({
      pathname: `/creator-profile/${creator_id}`,
      query: { ...query, page },
      shallow: true,
    });
  };

  renderGridLayout = () => {
    const {
      dataTypePattern,
      lng,
      collection,
      loading,
      currentLanguage,
    } = this.props;
    const imageSize = Config.getFixedSizeByDataType(dataTypePattern);
    if (Config.isUsingGridGallery(dataTypePattern)) {
      return (
        <GridGallery
          images={collection}
          currentLang={lng}
          lastRowHide={false}
          colWidth={imageSize.width}
          rowHeight={imageSize.height}
          showImageActions
        />
      );
    }
    if (Config.isIllustAC()) {
      return (
        <GalleryIllust
          images={collection}
          currentLang={currentLanguage}
          lastRowHide={false}
          prepareLoad={this.props.loading}
          showImageActions
          toggleFilterSearch={true} //fake = true to reduce count image in row
          isNotFullWidthCustom={true} // reduce count image when not full 100vw
        />
      );
    }
    return (
      <Gallery
        images={collection}
        currentLang={currentLanguage}
        lastRowHide={false}
        colWidth={imageSize.width}
        rowHeight={imageSize.height}
        prepareLoad={loading}
        showImageActions
      />
    );
  };

  onNextLink = () => {
    let {
      creator_id,
      lng,
      query,
      pagination: { page, total_page },
    } = this.props;
    if (page >= total_page) {
      return {};
    }
    page++;
    const path = urls.convertToQueryStrings({ ...query, page });
    return {
      asPath: `/creator-profile/${creator_id}?${path}`,
      query: { ...query, page },
    };
  };

  // onChangePerPage = (value) => {
  //   const { lng, creator_id } = this.props;
  //   this.props.changePerPage(value);

  //   const query = Object.assign(
  //     {},
  //     this.props.query,
  //     { max_results: value },
  //     { lang: lng },
  //   );

  //   const path = urls.convertToQueryStrings(query);

  //   this.props.loadCreatorData(query);
  //   Router.push(`/creator-profile/${creator_id}?${path}`, {
  //     shallow: true,
  //   });
  // };

  handleSeeMore = () => {
    this.setState({ seeMore: !this.state.seeMore });
  };

  renderPagination() {
    const {
      t,
      creator_id,
      query,
      pagination: { page, total_page, has_next, max_results: perPage },
      lng,
    } = this.props;

    return (
      <div className="pagination-wrapper">
        <PaginationNew
          currentPage={+page}
          totalPage={+total_page}
          onChange={this.onChangePage}
          query={query}
          path={'/creator-profile'}
          asPath={`/creator-profile/${creator_id}`}
        />
      </div>
    );
  }
  renderShareSocial = (t, lng, profile) => {
    return (
      <div className="social-container">
        <div
          className="button-share"
          onClick={() =>
            this.setState({ openShareSocial: !this.state.openShareSocial })
          }
        >
          <div className="icon-share">
            <IconShareProfile />
          </div>
          <div className="text">Share</div>
        </div>
        <div
          className={`container-show-content-share ${
            this.state.openShareSocial ? 'active' : ''
          }`}
        >
          <ButtonCopyLink t={t} lng={lng} />
          <ButtonSocialShare t={t} lng={lng} profile={profile} />
        </div>
        <style jsx>
          {`
            .social-container {
              display: flex;
              position: relative;
            }
            .button-share {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 128px;
              background: ${themeVariables.colors.primary};
              border-radius: 40px;
              height: 100%;
              gap: 8px;
              z-index: 1;
              cursor: pointer;
              color: #ffffff;
            }
            .button-share:hover {
              box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            }
            .container-show-content-share {
              display: flex;
              background: #f8f9fa;
              border: 1px solid #7a7a7a;
              box-sizing: border-box;
              border-radius: 40px;
              align-items: center;
              justify-content: center;
              gap: 8px;
              padding-left: 72px;
              padding-right: 8px;
              margin-left: -64px;
              z-index: 0;
              transition: 0.1s;
              opacity: 0;
            }
            .active {
              display: flex;
              opacity: 1;
            }
          `}
        </style>
      </div>
    );
  };
  render() {
    const {
      profile,
      t,
      // query,
      // creator_id,
      pagination: { page, total_page, has_next },
      lng,
      collection,
      loading,
    } = this.props;
    if (!profile) return null;
    // const selfIntroduction = profile.self_introduction || '';
    const creatorName = profile.nickname_for_overseas || profile.nickname; // || profile.name;

    return (
      <div className={Config.serviceType}>
        <Container className={containerHeader}>
          <div className="creator-profile-container">
            <div className="creator-profile-left-section">
              <div className="user-infor-container">
                <div className="avatar-container">
                  <Avatar src={profile.avatar} width={36} height={36} />
                </div>
                <div className="username-container">{creatorName}</div>
              </div>
              <div className="social-container">
                {!Config.isChina() && (
                  <div className="action-social">
                    {profile.facebook ? (
                      <a
                        href={
                          profile.facebook.startsWith('http')
                            ? profile.facebook
                            : `//${profile.facebook}`
                        }
                        // className="btn-creator-facebook active"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <IconFacebook />
                      </a>
                    ) : (
                      // <div className="btn-creator-facebook disable">
                      <div>
                        <IconFacebook />
                      </div>
                    )}
                    {profile.twitter ? (
                      <a
                        href={
                          profile.twitter.startsWith('http')
                            ? profile.twitter
                            : `//${profile.twitter}`
                        }
                        // className="btn-creator-twitter active"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <IconTwitter />
                      </a>
                    ) : (
                      // <div className="btn-creator-twitter disable">
                      <div>
                        <IconTwitter />
                      </div>
                    )}
                    {this.renderShareSocial(t, lng, profile)}
                  </div>
                )}
              </div>
            </div>
            <div className="creator-profile-right-section">
              <div className="item-infor-creator">
                <div className="icon-infor-container">
                  <IconAccountVerified />
                </div>
                <div className="data-item-infor">Verified</div>
              </div>
              <div className="item-infor-creator">
                <div className="icon-infor-container">
                  <IconCountDownload />
                </div>
                <div className="data-item-infor">
                  <FormatNumbers value={profile.downloaded} />
                </div>
              </div>
              <div className="item-infor-creator">
                <div className="icon-infor-container">
                  <IconLiketDownload />
                </div>
                <div className="data-item-infor">
                  <FormatNumbers value={profile.nice} />
                </div>
              </div>
              <div className="item-infor-creator">
                <div className="icon-infor-container">
                  <IconcCountImage />
                </div>
                <div className="data-item-infor">
                  <FormatNumbers value={profile.number_photos} />
                </div>
              </div>
            </div>
          </div>
        </Container>
        <Container>
          <div className="tab-header-container">
            <ButtonSelect
              label={t('popular')}
              checked={this.state.key === 'popular' ? true : false}
              data="popular"
              onChange={(e) => this.handleSelectTab(e)}
            />
            <ButtonSelect
              label={t('new')}
              checked={this.state.key === 'new' ? true : false}
              data="new"
              onChange={(e) => this.handleSelectTab(e)}
            />
          </div>
        </Container>
        <Container className={containerHeader}>
          <div className="creator-photos-gallery">
            {/* {!loading && this.renderGridLayout()} */}
            {!loading ? this.renderGridLayout() : <LoadingSpinner />}

            {collection && collection.length > 0 && (
              <div className="bottom-pagination">
                {has_next && (
                  <>
                    <NextPageButtonNew
                      query={this.onNextLink().query}
                      as={this.onNextLink().asPath}
                      t={t}
                    />
                  </>
                )}
                <div className="bottom-pagination">
                  {this.renderPagination()}
                </div>
              </div>
            )}
          </div>
        </Container>
        {!Config.isChina() && (
          <div className="comment-container-creator">
            <FacebookComment />
          </div>
        )}
        <style jsx>{`
          .creator-profile-container {
            display: flex;
            justify-content: space-between;
            padding-bottom: 32px;
            border-bottom: 1px solid #7a7a7a;
          }
          .creator-profile-left-section {
            display: flex;
            flex-direction: column;
            gap: 24px;
          }
          .user-infor-container {
            display: flex;
            gap: 24px;
          }
          .avatar-container {
            width: 36px;
            height: 36px;
          }
          .username-container {
            min-width: 120px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-weight: 600;
            font-size: 20px;
            line-height: 23px;
            color: #051019;
          }
          .social-container {
            display: flex;
          }
          .action-social {
            display: flex;
            gap: 12px;
          }
          .creator-profile-right-section {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
          }
          .item-infor-creator {
            width: 80px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
          .tab-header-container {
            display: flex;
            gap: 24px;
            align-items: center;
            justify-content: center;
            margin: 24px;
          }
          .bottom-pagination {
            display: flex;
            justify-content: space-between;
            margin-top: 32px;
          }
        `}</style>
        <style jsx global>
          {`
            .read-more-button {
              display: inline-block;
              margin-left: 3px;
              color: #286da8;
              cursor: pointer;
            }

            .creator-name {
              margin-top: 0;
              font-size: 24px;
              font-weight: normal;
            }

            .btn-creator-social .btn-creator-facebook {
              display: inline-block;
              padding: 0 4px;
              width: 50px;
              height: 50px;
              border-radius: 50%;
              border: 1px solid rgba(0, 0, 0, 0.1);
              overflow: hidden;
              margin-right: 5px;
            }
            .btn-creator-social .btn-creator-facebook svg {
              width: 20px;
              height: 20px;
              margin: 13px 10px;
            }

            .btn-creator-social .btn-creator-twitter {
              display: inline-block;
              padding: 0 4px;
              width: 50px;
              height: 50px;
              border-radius: 50%;
              border: 1px solid rgba(0, 0, 0, 0.1);
              overflow: hidden;
              margin-right: 5px;
            }
            .btn-creator-social .btn-creator-twitter svg {
              width: 20px;
              height: 20px;
              margin: 13px 10px;
            }

            .btn-creator-social .btn-creator-google {
              display: inline-block;
              padding: 0 4px;
              width: 50px;
              height: 50px;
              border-radius: 50%;
              border: 1px solid rgba(0, 0, 0, 0.1);
              overflow: hidden;
            }
            .btn-creator-social .btn-creator-google svg {
              width: 25px;
              height: 25px;
              margin: 11px 10px;
            }

            .btn-creator-social .btn-creator-facebook.disable,
            .btn-creator-social .btn-creator-twitter.disable,
            .btn-creator-social .btn-creator-google.disable {
              color: rgba(0, 0, 0, 0.1);
              border: 1px solid rgba(0, 0, 0, 0.1);
            }

            .photo_ac .btn-creator-facebook.active,
            .photo_ac .btn-creator-twitter.active,
            .photo_ac .btn-creator-google.active {
              color: #509bdc;
              border: 1px solid #509bdc;
            }

            .photo_ac .read-more-button {
              color: #509bdc;
            }

            .photo_ac .btn-creator-follow .badge {
              background-color: #509bdc;
              padding: 5px 15px;
            }

            .photo_ac .btn-creator-follow .badge + .badge {
              margin-left: 5px;
            }

            .photo_ac .btn-creator-info svg {
              color: #509bdc;
            }

            .photo_ac .btn-creator-camera svg {
              color: #509bdc;
            }

            .photo_ac .ac-tabs ul li.active a,
            .photo_ac .ac-tabs ul li.active a:focus,
            .photo_ac .ac-tabs ul li.active a:hover {
              border-bottom: 1px solid #509bdc;
            }

            .illust_ac .btn-creator-facebook.active,
            .illust_ac .btn-creator-twitter.active,
            .illust_ac .btn-creator-google.active {
              color: #d73a4e;
              border: 1px solid #d73a4e;
            }

            .illust_ac .read-more-button {
              color: #d73a4e;
            }

            .illust_ac .btn-creator-follow .badge {
              background-color: #d73a4e;
              padding: 5px 15px;
            }

            .illust_ac .btn-creator-follow .badge + .badge {
              margin-left: 5px;
            }

            .illust_ac .btn-creator-info svg {
              color: #d73a4e;
            }

            .illust_ac .btn-creator-camera svg {
              color: #d73a4e;
            }

            .illust_ac .ac-tabs ul li.active a,
            .illust_ac .ac-tabs ul li.active a:focus,
            .illust_ac .ac-tabs ul li.active a:hover {
              border-bottom: 1px solid #d73a4e;
            }

            .silhouette_ac .btn-creator-facebook.active,
            .silhouette_ac .btn-creator-twitter.active,
            .silhouette_ac .btn-creator-google.active {
              color: #41b9b8;
              border: 1px solid #41b9b8;
            }

            .silhouette_ac .read-more-button {
              color: #41b9b8;
            }

            .silhouette_ac .btn-creator-follow .badge {
              background-color: #41b9b8;
              padding: 5px 15px;
            }

            .silhouette_ac .btn-creator-follow .badge + .badge {
              margin-left: 5px;
            }

            .silhouette_ac .btn-creator-info svg {
              color: #41b9b8;
            }

            .silhouette_ac .btn-creator-camera svg {
              color: #41b9b8;
            }

            .silhouette_ac .ac-tabs ul.nav-tabs li.active a,
            .silhouette_ac .ac-tabs ul.nav-tabs li.active a:focus,
            .silhouette_ac .ac-tabs ul.nav-tabs li.active a:hover {
              border-bottom: 1px solid #41b9b8;
            }

            .design_ac .btn-creator-facebook.active,
            .design_ac .btn-creator-twitter.active,
            .design_ac .btn-creator-google.active {
              color: #ffa823;
              border: 1px solid #ffa823;
            }

            .design_ac .read-more-button {
              color: #ffa823;
            }

            .design_ac .btn-creator-follow .badge {
              background-color: #ffa823;
              padding: 5px 15px;
            }

            .design_ac .btn-creator-follow .badge + .badge {
              margin-left: 5px;
            }

            .design_ac .btn-creator-info svg {
              color: #ffa823;
            }

            .design_ac .btn-creator-camera svg {
              color: #ffa823;
            }

            .design_ac .ac-tabs ul li.active a,
            .design_ac .ac-tabs ul li.active a:focus,
            .design_ac .ac-tabs ul li.active a:hover {
              border-bottom: 1px solid #ffa823;
            }

            .btn-creator-info > div + div {
              margin-left: 15px;
            }

            .btn-creator-camera {
              width: 100%;
            }
            .btn-creator-camera .block-ellipsis {
              display: block;
              display: -webkit-box;
              max-width: 100%;
              height: 29px;
              margin: 0 auto;
              font-size: 14px;
              line-height: 1;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .ac-tabs {
              text-align: center;
            }
            .ac-tabs ul {
              display: inline-block;
              margin: 0;
              padding: 0;
              border: none;
            }
            .ac-tabs ul li a {
              border: none;
              border-bottom: 1px solid transparent;
              color: #1b2833;
              font-weight: 800;
              font-size: 14px;
            }
            .ac-tabs ul li.active a,
            .ac-tabs ul li.active a:focus,
            .ac-tabs ul li.active a:hover {
              border-top: none;
              border-left: none;
              border-right: none;
              background-color: transparent;
            }
            .ac-tabs ul li a:hover,
            .ac-tabs ul li a:focus {
              background-color: transparent;
              border-top: none;
              border-left: none;
              border-right: none;
            }

            .LinesEllipsis-ellipsis {
              color: #259;
              cursor: pointer;
            }

            .content-image {
              margin-bottom: 0;
              margin-top: -1px;
              height: 400px;
            }

            .comment-container-creator {
              width: 50%;
              min-width: 700px;
              margin: 14px auto;
            }

            .btn-creator-info {
              font-size: 14px;
              display: flex;
              flex-direction: row;
            }
            .btn-creator-info .creator-info-item {
              margin-right: 20px;
            }
            .btn-creator-info svg {
              font-size: 22px;
            }

            .container-tabs-pagination {
              position: relative;
            }
            .container-tabs-pagination .top-pagination {
              position: absolute;
              right: 0;
              bottom: 0;
            }

            .tabs-creator {
              width: 30%;
              margin: 0 auto;
              margin-top: 5px;
            }
            .tabs-creator ul.tab-creator-item li a {
              color: #1b2833;
              font-weight: 800;
              font-size: 14px;
              margin: 0 16px;
            }
            .tabs-creator ul.tab-creator-item li a,
            .tabs-creator ul.tab-creator-item li a:hover,
            .tabs-creator ul.tab-creator-item li a:active,
            .tabs-creator ul.tab-creator-item li a:focus {
              border: none;
              background-color: transparent;
              border-bottom: 2px solid transparent;
            }
            .tabs-creator ul.tab-creator-item li {
              padding-bottom: 3px;
            }
            .tabs-creator ul.tab-creator-item li.active a,
            .tabs-creator ul.tab-creator-item li.active a:hover,
            .tabs-creator ul.tab-creator-item li.active a:active,
            .tabs-creator ul.tab-creator-item li.active a:focus {
              border: none;
              padding-bottom: 4px !important;
            }
            .tabs-creator ul.tab-creator-item.photo_ac li.active a,
            .tabs-creator ul.tab-creator-item.photo_ac li.active a:hover,
            .tabs-creator ul.tab-creator-item.photo_ac li.active a:active,
            .tabs-creator ul.tab-creator-item.photo_ac li.active a:focus {
              border-bottom: 2px solid #509bdc;
            }
            .tabs-creator ul.tab-creator-item.illust_ac li.active a,
            .tabs-creator ul.tab-creator-item.illust_ac li.active a:hover,
            .tabs-creator ul.tab-creator-item.illust_ac li.active a:active,
            .tabs-creator ul.tab-creator-item.illust_ac li.active a:focus {
              border-bottom: 2px solid #d73a4e;
            }
            .tabs-creator ul.tab-creator-item.silhouette_ac li.active a,
            .tabs-creator ul.tab-creator-item.silhouette_ac li.active a:hover,
            .tabs-creator ul.tab-creator-item.silhouette_ac li.active a:active,
            .tabs-creator ul.tab-creator-item.silhouette_ac li.active a:focus {
              border-bottom: 2px solid #41b9b8;
            }
            .tabs-creator ul.tab-creator-item.design_ac li.active a,
            .tabs-creator ul.tab-creator-item.design_ac li.active a:hover,
            .tabs-creator ul.tab-creator-item.design_ac li.active a:active,
            .tabs-creator ul.tab-creator-item.design_ac li.active a:focus {
              border-bottom: 2px solid #ffa823;
            }
            @media (max-width: 992px) {
              .tabs-creator {
                width: 50%;
              }
            }

            .creator-photos-container {
              margin-top: 28px;
              padding: 0 14px;
              background: #f2f3f4;
            }
            .creator-photos-container .pagination-wrapper {
              display: flex;
              flex-direction: row;
              float: right;
            }
            .creator-photos-container .pagination-wrapper .filter-item {
              display: flex;
              min-width: 350px;
            }
            .creator-photos-container .pagination-wrapper .filter-title {
              flex-basis: 0;
              flex-grow: 1;
            }
            .creator-photos-container .pagination-wrapper .filter-content {
              flex-basis: 0;
              flex-grow: 2;
              display: flex;
            }
            .creator-photos-container .bottom-pagination-see-more {
              position: relative;
              display: flex;
              flex-direction: row;
              justify-content: center;
              margin: 24px 0;
            }
            .creator-photos-container
              .bottom-pagination-see-more
              .bottom-pagination {
              position: absolute;
              bottom: 10px;
              right: 0;
            }
            @media (max-width: 767px) {
              .creator-photos-container
                .bottom-pagination-see-more
                .bottom-pagination {
                bottom: 85px;
                right: -10px;
              }
              .tabs-creator {
                padding-bottom: 70px;
              }
            }
          `}
        </style>
        {containerStylesHeader}
      </div>
    );
  }
}
const {
  className: containerHeader,
  styles: containerStylesHeader,
} = css.resolve`
  margin-top: 20px;
`;
const mapStateToProps = createStructuredSelector({
  profile: makeSelectProfile(),
  collection: makeSelectCollection(),
  dataTypePattern: makeSelectDataTypePattern(),
  loading: makeSelectLoading(),
  pagination: makeSelectPagination(),
  currentLanguage: makeSelectCurrentLanguage(),
});
const mapDispatchToProps = (dispatch) => ({
  changePage: (value) => dispatch(changePage(value)),
  loadCreatorData: (value) => dispatch(loadCreatorData(value)),
  changePerPage: (value) => dispatch(changePerPage(value)),
});
export default connect(mapStateToProps, mapDispatchToProps)(CreatorProfilePage);
